import { createSharedComposable } from '@vueuse/shared';
import { useApiClient } from '@/app/core/api-client';
import type { PaginationQuery, PaginatedResponse, OffsetLimitResponse, OffsetLimitQuery } from '@/app/shared/types';
import { config } from '@/app/core/config';
import type { Download, Upload } from '../../interfaces';

export const useDataCenterApi = createSharedComposable(() => {
  const { transport, createMethod } = useApiClient();

  function getDownloads(params?: PaginationQuery & { type?: string; status?: string }) {
    return transport.get<PaginatedResponse<Download>>('v1/downloads', { params });
  }

  function getDownloadsByIds(ids: string[]) {
    return transport.post<PaginatedResponse<Download>>('v1/downloads/by_ids', {
      ids,
    });
  }

  function getDownloadLink(id: string) {
    return transport.get<{ url: string }>(`/v1/downloads/${id}/download`);
  }

  const getUploads = createMethod<[OffsetLimitQuery], OffsetLimitResponse<Upload>>(
    async (transport, params: OffsetLimitQuery) => {
      const { data } = await transport.get<OffsetLimitResponse<Upload>>('/v1/data-center/uploads', {
        params,
        baseURL: config.bffUrl,
      });
      return data;
    },
  );

  return {
    getDownloads,
    getDownloadsByIds,
    getDownloadLink,
    getUploads,
  };
});
